// extracted by mini-css-extract-plugin
export default {"mpl":"q","index":"r","main":"s"};